import { gql } from '@apollo/client';

export const GET_OATT_NSP_CORE_INFO_LIST = gql`
  query GetOattNspCoreInfoList {
    oattNspCoreInfoList {
      oatt_nsp_core_info_id
      entry_type
      company_name
      address
      city
      province
      postal_code
      hst_rate
      approver_email
      contact_name
      contact_phone
      contact_email
      approver_name
      logo_url
      created_at
      updated_at
    }
  }
`;

export const UPDATE_OATT_NSP_CORE_INFO = gql`
  mutation UpdateOattNspCoreInfo($oattNspCoreInfoId: Int!, $input: UpdateOattNspCoreInfoInput!) {
    updateOattNspCoreInfo(oattNspCoreInfoId: $oattNspCoreInfoId, input: $input) {
      success
      message
      data {
        oatt_nsp_core_info_id
        company_name
        address
        city
        province
        postal_code
        hst_rate
        approver_email
        contact_name
        contact_phone
        contact_email
        updated_at
      }
    }
  }
`;
